import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * fetchRingoverChunks ahora acepta un parámetro opcional `period`:
 *   { from: Date | 'YYYY-MM-DD' | null, to: Date | 'YYYY-MM-DD' | null }
 *
 * Si from/to son null, devuelve todo el periodo.
 * Si llegan como Date (lo que emite PeriodFilter), los formateamos a
 * 'YYYY-MM-DD' en local time — axios serializaría un Date a ISO con T/Z
 * y el backend (isValidDateStr estricto) lo descartaría sin avisar.
 */
const ymd = (d) => d instanceof Date
    ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    : d;

export const fetchRingoverChunks = async (period = null) => {
    try {
        const params = {};
        if (period?.from) params.from = ymd(period.from);
        if (period?.to)   params.to   = ymd(period.to);

        const response = await axios.get(`${API_URL}/api/ringover/chunks`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            },
            params,
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const importRingoverCsv = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axios.post(`${API_URL}/api/ringover/import`, formData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const deleteRingoverMonth = async (year, month) => {
    try {
        const response = await axios.delete(`${API_URL}/api/ringover/months/${year}/${month}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchRingoverImports = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/ringover/imports`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// NUEVO: catálogo de usuarios RingOver (solo Super Admin)
export const fetchRingoverUsers = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/ringover/users`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// NUEVO: actualizar inclusión/nombre de usuarios (solo Super Admin)
// updates: [{ Id, incluir, nombreMostrado? }]
export const updateRingoverUsers = async (updates) => {
    try {
        const response = await axios.put(`${API_URL}/api/ringover/users`,
            { updates },
            { headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` } }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// NUEVO: dispara sincronización por API de RingOver (solo Super Admin).
// Sin parámetros — el backend calcula el rango automáticamente desde la
// última sync exitosa. Puede tardar varios segundos en datasets grandes.
export const syncRingoverAhora = async () => {
    try {
        const response = await axios.post(
            `${API_URL}/api/ringover/sync`,
            {},
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("token")}`,
                },
                timeout: 120000, // 2 min — la sync puede ser larga
            }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// NUEVO: lee la última entrada de ringover_imports (sync API / CSV / backfill).
// Sirve para mostrar la marca "Última sincronización" en el dashboard.
// Solo requiere auth — visible para cualquier usuario autenticado.
export const fetchLastImport = async () => {
    try {
        const response = await axios.get(
            `${API_URL}/api/ringover/last-import`,
            { headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` } }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
